<template>
  <v-layout class="wrapper" row wrap>
    <main-banner/>
    <v-flex xs12 sm6 offset-sm3>
      <v-card class="my-2 mx-4">
        <v-card-text>
          <div
            class="primary--text"
          >
            A verification code has been sent to your email address.
          </div>
          <div
            v-if="invalidPassword"
            class="red--text"
          >
            Invalid password or verification code
          </div>
          <v-text-field
            class="form-field"
            label="Verification Code"
            v-model="verificationCode"
            id="verification-code"
            @keyup.enter="confirmAndLogin"
          ></v-text-field>
          <PasswordField
            class="form-field"
            label="New Password"
            v-model="newPassword"
            id="new-password"
            @keyup.enter="confirmAndLogin"
          />
          <v-text-field
            class="form-field"
            label="Password Confirmation"
            v-model="passwordConfirmation"
            id="password-confirmation"
            type="password"
            @keyup.enter="confirmAndLogin"
          ></v-text-field>
          <PasswordRequirements/>
          <div
            v-if="showMatchError"
            class="red--text"
          >
            Passwords do not match
          </div>
          <v-btn
            class="mx-0 full-width secondary"
            @click="confirmAndLogin"
            id="change-password-button"
          >
            Login
          </v-btn>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
  import MainBanner from 'Components/MainBanner.vue'
  import PasswordRequirements from 'Components/PasswordRequirements.vue'
  import PasswordField from '@/components/PasswordTextField.vue'
  import LoginPage from 'Mixins/LoginPage.js'
  import { mapActions, mapState } from 'vuex'

  export default {
    name: 'forgot-password-change',
    components: {
      MainBanner,
      PasswordField,
      PasswordRequirements
    },
    mixins: [LoginPage],
    data () {
      return {
        verificationCode: '',
        newPassword: '',
        passwordConfirmation: '',
        invalidPassword: false,
        checkPasswordMatch: false,
      }
    },
    computed: {
      ...mapState({
        changePasswordData: state => state.cognito.changePasswordData
      }),
      showMatchError () {
        return this.checkPasswordMatch &&
          (this.newPassword !== this.passwordConfirmation)
      }
    },
    methods: {
      ...mapActions([
        'confirmPassword',
      ]),
      confirmAndLogin () {
        if (this.newPassword === this.passwordConfirmation) {
          const { username } = this.changePasswordData
          const { verificationCode, newPassword } = this
          this.confirmPassword({ username, verificationCode, newPassword })
            .then(() => {
              this.login({ username, password: newPassword })
                .then(() => {
                  this.getUserAndPlans()
                })
            }).catch(error => {
              this.invalidPassword = true
              console.log(error)
            })
        } else {
          this.checkPasswordMatch = true
        }
      }
    }
  }
</script>
<style scoped>
.wrapper {
    background-color: #4b91e3;
    height: 100%
  }
</style>
